import { PermissionsData } from '../modules/login/PermissionsResponse'

export const needCertificate = (permissions: PermissionsData): boolean => {
  return permissions?.platforms.map(platform => platform.features.some(
    f => f.requireCertificate
  )).some(c => c)
}
